import { render } from "./PersonalSavingsProcessFinished.vue?vue&type=template&id=d25470fc&scoped=true"
import script from "./PersonalSavingsProcessFinished.vue?vue&type=script&lang=js"
export * from "./PersonalSavingsProcessFinished.vue?vue&type=script&lang=js"

import "./PersonalSavingsProcessFinished.vue?vue&type=style&index=0&id=d25470fc&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25470fc"]])

export default __exports__